import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { Dayjs } from 'dayjs';
import { t } from 'ember-intl';

import styles from './pricing-assistant-table-tooltip.module.css';

/* The values the tooltip shows, besides the date. */
export interface LeftToSellTooltip {
  leftToSell: number;
  overbooking: number;
  // The hotel level has no Room row
  roomName?: string;
}

interface HotelPricingAssistantTableTooltipsTooltipLeftToSellSignature {
  Args: LeftToSellTooltip & { date: Dayjs };
}

export default class HotelPricingAssistantTableTooltipsTooltipLeftToSell extends Component<HotelPricingAssistantTableTooltipsTooltipLeftToSellSignature> {
  @service declare dates: Services['dates'];

  get formattedDate(): string {
    return this.args.date.format(
      this.dates.partialDateFormat.WEEKDAY_AND_DATE_LONG,
    );
  }

  <template>
    <EmberTooltip
      @side="bottom"
      @tooltipClass="base-tooltip {{styles.container}}"
    >
      <div class="{{styles.header}} flex items-center p-400">
        <h4>
          {{this.formattedDate}}
        </h4>
      </div>
      <div>
        <table
          class="default-table {{styles.table}} {{styles.wrapping-names-table}}"
        >
          <tbody>
            {{#if @roomName}}
              <tr data-test-id="tooltip-left-to-sell-room-row">
                <td class="{{styles.table-row-cell}} text-200--regular">
                  <p class="text-200--regular {{styles.fixed-cell}}">
                    {{t "pricing_manager.room"}}
                  </p>
                  <p
                    class="text-200--regular text-right
                      {{styles.wrapping-cell}}"
                  >
                    {{@roomName}}
                  </p>
                </td>
              </tr>
            {{/if}}
            <tr>
              <td class="{{styles.table-row-cell}} text-200--regular">
                <p class="text-200--regular {{styles.wrapping-cell}}">
                  {{t
                    "pricing_manager.monthly_table.left_to_sell_incl_overbooking"
                    overbooking=@overbooking
                  }}
                </p>
                <p class="text-200--regular {{styles.fixed-cell}}">
                  {{@leftToSell}}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </EmberTooltip>
  </template>
}
